import { useEffect, useState } from "react";
import { LoaderCircle } from "lucide-react";
import { ELENCO_BOLLETTE, bolletteInAnalisi, pronteSu } from "./scritte";

/** Sul telefono e sul Fold (sotto i 1024 px): una striscia che resta in cima mentre la pagina scorre, finché ci sono
 *  bollette in analisi (mockup «stato telefono», variante B). Compare solo quando l'elenco «Bollette caricate»
 *  non si vede. Non `fixed`: la testata del portale non è fissa, così sta sotto di lei in cima; non occupa spazio
 *  (ui-ux-pro-max: fixed-element-offset; touch-target-size 44 px; reduced-motion; aria-live polite). */
export function StrisciaStato({ inAnalisi, pronte, totale }: { inAnalisi: number; pronte: number; totale: number }) {
  const serve = inAnalisi > 0;
  // «Bollette caricate» dice già «lette su»: finché si vede la striscia starebbe a ripetere un numero diverso. Il margine
  // in alto è la sua altezza: un elenco sotto la striscia non conta come visibile.
  const [elencoInVista, setElencoInVista] = useState(false);
  useEffect(() => {
    const el = serve ? document.getElementById(ELENCO_BOLLETTE) : null;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const o = new IntersectionObserver(([e]) => setElencoInVista(e.isIntersecting), { rootMargin: "-45px 0px 0px 0px" });
    o.observe(el);
    return () => { o.disconnect(); setElencoInVista(false); };
  }, [serve]);
  if (!serve || elencoInVista) return null;
  const vai = () => {
    const ridotto = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    document.getElementById(ELENCO_BOLLETTE)?.scrollIntoView({ block: "start", behavior: ridotto ? "auto" : "smooth" });
  };
  return (
    // contenitore alto zero e fermo in cima: la striscia ci sta sopra senza spostare la pagina quando compare o sparisce
    <div className="sticky top-0 z-20 h-0 lg:hidden">
    <div
      data-testid="striscia-stato"
      className="absolute inset-x-0 top-0 -mx-4 border-b border-border bg-card md:-mx-6 lg:hidden"
    >
      <button
        type="button"
        onClick={vai}
        className="flex min-h-11 w-full cursor-pointer items-center justify-between gap-3 px-4 text-sm text-text hover:bg-surface transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand"
      >
        <span role="status" aria-live="polite" className="flex w-full items-center justify-between gap-3">
          <span className="flex items-center gap-1.5 font-medium">
            <LoaderCircle size={16} className="animate-spin text-brand-dark motion-reduce:animate-none" aria-hidden="true" />
            {bolletteInAnalisi(inAnalisi)}
          </span>
          <span className="whitespace-nowrap tabular-nums text-muted-foreground">{pronteSu(pronte, totale)}</span>
        </span>
      </button>
    </div>
    </div>
  );
}
